import type { NsDict } from '../ru';

export const lobby: NsDict<'lobby'> = {
  balance: 'Guthaben',
  atTables: 'An Tischen',
  openTables: 'Offene Tische',
  rulesBtn: 'Regeln und Gewinnberechnung',

  flowTitle: 'So läuft ein Spiel ab',
  'flow.prep': 'Vorbereitung',
  'flow.prepTextAnte': 'Ante {ante|cr} in den Pot, Hash der Zusammensetzung veröffentlicht',
  'flow.round1': 'Runde 1 · Chart',
  'flow.round1Text': 'ohne Preisskala; Wahl der Richtung',
  'flow.round2': 'Runde 2 · Skala',
  'flow.round2TextWr': 'Preise und Punkte; die Richtung kann geändert werden',
  'flow.round3': 'Runde 3 · Zusammensetzung',
  'flow.round3TextWr': 'drei Aktien aufgedeckt; nur die Anzahl der Punkte',
  'flow.target': 'Zielkerze',
  'flow.targetText': 'P₁ — Schluss der nächsten Minute',
  'flow.settleWr': 'Abrechnung',
  'flow.settleTextWr': 'es gewinnen alle mit der richtigen Richtung; der Anteil hängt von der Genauigkeit ab',

  'cat.n10': 'Einsteiger',
  'cat.n50': 'Standard',
  'cat.n200': 'Hoch',
  notEnough: 'Nicht genug Credits für das Ante.',

  'room.playing': 'Spiel läuft',
  'room.startIn': 'Start in {n} s',
  'room.settling': 'Abrechnung',
  'room.ready': 'bereit {ready} von {min}',
  'room.taken': 'belegt {seated} von {max}',
  'room.open': 'Öffnen',
  'room.watch': 'Zuschauen',

  'wr.startIn': 'Das Spiel beginnt in {n} s',
  'wr.waitMore': 'Warten auf {n} weitere Bestätigung|Warten auf {n} weitere Bestätigungen',
  'wr.allReady': 'Alle sind bereit',
  'wr.preparing': 'Das nächste Spiel wird vorbereitet',
  'wr.summary': 'Tisch {ante|cr} · {min}–{max} Spieler · am Tisch {seated}, bereit {ready}',
  'wr.botsNote': 'Wenn nicht genug Personen da sind, füllen Bots den Tisch auf (sie sind gekennzeichnet).',
  'wr.spectating': 'Sie schauen an diesem Tisch zu.',
  'wr.confirmed': '✓ Teilnahme bestätigt.',
  'wr.anteOnStart': 'Das Ante von {ante|cr} wird beim Start abgebucht.',
  'wr.cancel': 'Teilnahme zurückziehen',
  'wr.join': 'Teilnehmen · Ante {ante|cr}',
  'wr.yourBalance': 'Ihr Guthaben {amount|cr}',
  'wr.seats': 'Plätze am Tisch',
  'wr.you': 'Sie',
  'wr.gamesCount': 'Spiele: {n}',
  'wr.winRateShort': 'GQ',
  'wr.offline': 'keine Verbindung',
  'wr.ready': 'bereit',
  'wr.waiting': 'wartet',
  'wr.free': 'frei',

  'rules.title': 'Regeln von Market Table',
  'rules.demo': 'Eine Demo mit Spiel-Credits. Es gibt kein echtes Geld, keine Zahlungen, keinen Kauf und keine Auszahlung von Credits. Keine Anlageempfehlung.',
  'rules.indexTitle': 'Der Spielindex',
  'rules.indexText':
    'Vor jedem Spiel wählt der Server zufällig drei verschiedene Aktien aus einer offenen Auswahl liquider S&P-500-Aktien. Der Index ist eine gleichgewichtete Kombination ihrer prozentualen Veränderungen gegenüber dem Schluss der Kerze P₀:',
  'rules.index1': 'Bᵢ — Schlusskurs der Aktie in der Kerze P₀; Preisschritt {tick} Punkte; Rundung auf den nächsten Schritt, die Hälfte wird aufgerundet.',
  'rules.index2': 'O/C der Kerze — Index aus Eröffnungs-/Schlusskursen; H/L — aus Hochs/Tiefs der Komponenten (Schätzung nach oben/unten), aber nie enger als O und C.',
  'rules.index3': 'In einer Minute ohne Umsätze in einer Aktie wird ihr letzter Kurs verwendet.',
  'rules.index4': '„Aktivität“ — das über die drei Aktien gemittelte Minutenvolumen, geteilt durch das durchschnittliche Volumen der Aktie im Verlaufsfenster (1 = normal). VWAP* ist nach Aktivität gewichtet.',
  'rules.index5': 'Die Formel ist offen; verdeckt ist nur die Zusammensetzung des Trios — bis zur dritten Runde. Das Hash-Commitment wird vor den Einsätzen veröffentlicht und nach der Abrechnung aufgedeckt.',
  'rules.flowTitle': 'Ablauf eines Spiels',
  'rules.flow1': 'Das Ante N geht in den Pot, P₀ wird festgehalten.',
  'rules.flow2': 'Runde 1: Chart ohne Skala, Wahl der Richtung (höher/tiefer) und Einsätze.',
  'rules.flow3': 'Runde 2: Die Preisskala und die Abstände in Punkten werden aufgedeckt. Die Richtung kann beibehalten oder geändert werden.',
  'rules.flow4': 'Runde 3: Die Zusammensetzung wird aufgedeckt. Die Richtung ändert sich nicht mehr — geben Sie eine streng positive Anzahl Punkte an (Schritt {tick}).',
  'rules.flow5': 'Fixierung. P₁ ist der Schluss der nächsten Minutenkerze; Δ = P₁ − P₀.',
  'rules.actionsTitle': 'Aktionen',
  'rules.actionsText':
    'Fold, Check, Bet, Call, Raise (höchstens eine Erhöhung nach dem ersten Einsatz in der Runde), All-in (mit Side-Pots). Zeit pro Zug: {s} s; bei Zeitablauf Check, wenn möglich, sonst Fold. Am Ende der Runde foldet nur, wessen Zugzeit abgelaufen ist. Wer keinen Zug mehr bekommen hat, bleibt im Spiel: der nicht gecallte Teil des Einsatzes wird zurückgegeben. Wer bei der Fixierung keine vollständige Prognose hat, scheidet aus.',
  'rules.payoutTitle': 'Gewinner und Auszahlungen',
  'rules.payout1': 'Eine falsche Richtung verliert immer, auch bei exakter Punktzahl.',
  'rules.payout2':
    'Für alle mit richtiger Richtung: Fehler = |Prognose − |Δ||; Gewicht = Beitrag_zum_Pot / (1 + Fehler / {tick}). Der Pot wird im Verhältnis der Gewichte geteilt; Reste von 0,01 Cr nach dem Verfahren der größten Reste, bei Gleichstand nach Zugreihenfolge.',
  'rules.payout3': 'Jeder Side-Pot wird separat abgerechnet; Anspruch haben nur, wer eingezahlt und nicht gefoldet hat. Ein Pot ohne richtige Richtung geht an die Einzahler zurück.',
  'rules.payout4': 'Abbruch mit voller Rückerstattung und ohne Kommission: P₁ = P₀; niemand der Verbliebenen hat die Richtung erraten; keine verlässlichen Daten.',
  'rules.payout5': 'Haben alle bis auf einen gefoldet, erhält der Verbliebene den Pot ohne Prüfung der Prognose.',
  'rules.exampleTitle': 'Beispiel',
  'rules.exampleText':
    'Vier Spieler, Ante 10 Cr; Δ = +2,00. Spieler A: „höher 2,00“ (Fehler 0, Gewicht 10), B: „höher 2,25“ (Fehler 0,25 = 1 Schritt, Gewicht 10/2 = 5), C und D — „tiefer“. Pot 40 Cr, Kommission 5 % = 2 Cr; zu verteilen 38 Cr: A — 25,33 Cr, B — 12,67 Cr.',
  'rules.commissionTitle': 'Kommission',
  'rules.commissionText':
    '{pct} % der neuen Credits, die in jeder Runde in den Pot eingezahlt werden (in der ersten zusammen mit den Antes). Früher Eingezahltes und Zurückgegebenes wird nicht belastet; bei Abbruch wird keine Kommission einbehalten.',
  'rules.capOne': 'ein Ante',
  'rules.capMany': '{n} Ante|{n} Antes',
  'rules.cap': 'Die Obergrenze liegt bei {antes} N pro Runde, also höchstens {max}N pro Spiel (wie ein Rake-Cap beim Poker).',
  'rules.retained': 'Der einbehaltene Betrag fließt auf ein separates Hauskonto der Demo.',
  'rules.hotkeysTitle': 'Tastenkürzel',
  'rules.hotkeys': '↑/↓ Richtung · +/− Punkte (Shift ×4) · F Fold · C Check/Call · B Bet/Raise · A All-in · Enter bestätigen · Esc abbrechen',
  // ── режимы игры (0.8.0) ──
  'pickTitle': 'Spiel wählen',
  'pickIntro': 'Zwei Modi, zwei Charaktere. Wählen Sie Modus und Tisch: 4 bis 8 Spieler, ein Spiel dauert drei Minuten.',
  'variant.blind3.title': 'Blinde Drei',
  'variant.blind3.tag': '3 aus 500',
  'variant.blind3.text': 'Drei zufällige S&P-500-Aktien, Namen bis zur letzten Runde verborgen. Externe Analysetools helfen nicht: Alle am Tisch haben gleiche Chancen — es entscheiden Chartlesen und Nervenstärke.',
  'variant.blind3.badge': 'faire Chancen',
  'variant.blind3.f1': 'Zusammensetzung bis Runde 3 verborgen',
  'variant.blind3.f2': 'Richtung in Runden 1–2',
  'variant.spx.title': 'Offene Karten',
  'variant.spx.tag': 'S&P 500',
  'variant.spx.text': 'Das Instrument ist vorab bekannt, der echte Preis ab der ersten Sekunde sichtbar. Nutzen Sie Ihre ganze Analyse und eigene Tools. Ein Modus für Selbstbewusste.',
  'variant.spx.badge': 'für Selbstbewusste',
  'variant.spx.f1': 'Instrument {symbol}, Preis sofort sichtbar',
  'variant.spx.f2': 'Richtung nur in Runde 1',
  'variant.spx.demoNote': 'Demo: Kurse des SPY-Fonds aus einem zufälligen Moment der letzten Tage.',
  'tier.ante': 'Einsatz',
  'tier.seated': 'am Tisch: {n}',
  'tier.empty': 'frei',
  'tier.mine': 'Sie sind hier',
  'tier.aria': 'Am Tisch {ante|cr} Platz nehmen · {variant}',
  'chooseTable': 'Tisch wählen',
  'liveTitle': 'Tische jetzt',
  'liveEmpty': 'Noch spielt kein Tisch — wählen Sie oben Modus und Tisch.',
  'flow.open.prepText': 'Einsatz {ante|cr} in den Pot; Instrument und Preis sofort sichtbar',
  'flow.open.round1': 'Runde 1 · Richtung',
  'flow.open.round1Text': 'Richtung wählen; danach ist sie fest',
  'flow.open.round2': 'Runde 2 · Punkte',
  'flow.open.round2Text': 'nur die Punktzahl',
  'flow.open.round3': 'Runde 3 · Punkte',
  'flow.open.round3Text': 'letzte Anpassung der Punkte',
  'rules.variantsTitle': 'Spielmodi',
  'rules.variantBlind3': 'Blinde Drei (3 aus 500): Index aus drei zufälligen Aktien; Preisskala bis Runde 2, Zusammensetzung bis Runde 3 verborgen. Die Richtung wird in der Vorbereitung und in Runden 1–2 gewählt.',
  'rules.variantSpx': 'Offene Karten (S&P 500): ein bekanntes Instrument und sein echter Preis in Dollar mit Schritt 0,01; Chart und Preis sind von Anfang an sichtbar. Die Richtung wird in der Vorbereitung und in Runde 1 gewählt, in Runden 2–3 ändert sich nur die Punktzahl (1 Punkt = 1 $). Im Demo der SPY-Fonds zu einem zufälligen Moment der letzten Tage. Einsätze, Provision und Abrechnung gelten für beide Modi.',
  // ── режимы игры (0.8.0) ──
  // ── подпись «демо» и карточки «скоро» (0.8.1) ──
  'variant.demo': 'Demo',
  'soon.label': 'demnächst',
  'soon.sub': 'um Dollar · demnächst',
  'soon.tier': 'bald',
  'soon.toast': 'Dollar-Tische kommen bald.',
  'soon.aria': 'Tisch {amount} $ · {variant} — demnächst',
};
